import * as stickybits from 'stickybits'; // Documentation: https://github.com/yowainwright/stickybits#readme
import passiveIfSupported from "../lib/passiveIfSupported";
import Debouncer from "../lib/Debouncer";

export interface StickyBitsConfig {
	elementsQuery: string;
	elementOffset: number;
}

export default class StickyBits {
	private stickybit: any;
	private elem: HTMLElement;
	private config: StickyBitsConfig;

	public static init(config: StickyBitsConfig) {
		const elems = document.querySelectorAll(config.elementsQuery);
		if (elems.length === 0) {
			return;
		}
		for (let i = 0; i < elems.length; i++) {
			const elem = elems[i];
			if (elem instanceof HTMLElement) {
				new StickyBits(config, elem as HTMLElement);
			}
		}
	}

	private constructor(config: StickyBitsConfig, elem: HTMLElement) {
		this.elem = elem;
		this.config = config;
		
		this.update = this.update.bind(this);

		const debouncedUpdate = new Debouncer(this.update);
		window.addEventListener("scroll", debouncedUpdate.run, passiveIfSupported);
		window.addEventListener("resize", debouncedUpdate.run, passiveIfSupported);
		const mutationObserver = new MutationObserver(debouncedUpdate.run);
		mutationObserver.observe(this.elem.ownerDocument, {
			childList: true,
			subtree: true,
			characterData: false,
			attributes: false
		});
		debouncedUpdate.runNow();
	}

	private update() {
		if (this.elem.offsetHeight + 30 > window.document.documentElement.clientHeight) {
			if (this.stickybit !== undefined) {
				this.stickybit.cleanup();
				this.stickybit = undefined;
			}
		} else {
			if (this.stickybit === undefined) {
				this.stickybit = (stickybits as any)(
					this.elem,
					{
						useFixed: true,
						stickyBitStickyOffset: this.config.elementOffset,
						useGetBoundingClientRect: true
					}
				);
			} else {
				this.stickybit.update();
			}
		}
	}
}
